import { UpdateCompanyAddress } from '../editCompany/updateCompanyAddress';
import { useHasPermission } from '../../../hooks/useHasPermission';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import Iconify from '../../Iconify';
import { useState } from 'react';
import '../../../css//companies/oneCompanyDetails/companyAddress.css';

const CompanyAddress = () => {

    const { street_address, address_line_2, city, postal_code, can_manage_machine_control } = useSelector((state) => state.CompanyDetailsData || {});
    const hasCompanyUpdatePermission = useHasPermission('entreprise_update');
    const [openUpdateAddress, setOpenUpdateAddress] = useState(false);

    const handleEditClick = () => setOpenUpdateAddress(true);

    return (
        <Box className='CompanyAddress_main_box'>

            <Box className='CompanyAddress_box'>
                <Box className='localisation_edit_box'>
                    <Typography className='CompanyAddress_title'>Localisation et rattachement</Typography>
                    {hasCompanyUpdatePermission && <Iconify className='CompanyAddress_edit_icon' icon="ic:outline-edit" onClick={handleEditClick} />}
                </Box>
                <Box className='localisationEtStatut_icon_title_response_box'>
                    <Iconify icon={"hugeicons:address-book"} width="32px" />
                    <Box className='localisationEtStatut_response_box'>
                        <Typography className='localisationEtStatut_text'>Address: </Typography>
                        <Typography className='localisationEtStatut_text_localisation'>{street_address || '--'}</Typography>
                    </Box>
                </Box>
                <Box className='localisationEtStatut_icon_title_response_box'>
                    <Iconify icon={"hugeicons:address-book"} width="32px" />
                    <Box className='localisationEtStatut_response_box'>
                        <Typography className='localisationEtStatut_text'>Complément d'adresse: </Typography>
                        <Typography className='localisationEtStatut_text_localisation'>{address_line_2 || '--'}</Typography>
                    </Box>
                </Box>
                <Box className='localisationEtStatut_icon_title_response_box'>
                    <Iconify icon={"mdi:address-marker-outline"} width="32px" />
                    <Box className='localisationEtStatut_response_box'>
                        <Typography className='localisationEtStatut_text'>Postal code: </Typography>
                        <Typography className='localisationEtStatut_text_localisation'>{postal_code || '--'}</Typography>
                    </Box>
                </Box>
                <Box className='localisationEtStatut_icon_title_response_box'>
                    <Iconify icon={"ph:city"} width="32px" />
                    <Box className='localisationEtStatut_response_box'>
                        <Typography className='localisationEtStatut_text'>Ville: </Typography>
                        <Typography className='localisationEtStatut_text_localisation'>{city || '--'}</Typography>
                    </Box>
                </Box>
                <Box className='localisation_edit_box'>
                    <Typography className='CompanyAddress_title'>Contrôle des machines</Typography>
                </Box>
                <Box className='CompanyAddress_gerer_control_box'>
                    <Typography className='CompanyAddress_gerer_control'>Peut gérer le contrôle des machines: </Typography>
                    <Typography >{can_manage_machine_control ? 'Oui' : 'Non'} </Typography>
                </Box>
            </Box>

            {openUpdateAddress &&
                <UpdateCompanyAddress
                    openUpdateAddress={openUpdateAddress}
                    setOpenUpdateAddress={setOpenUpdateAddress}
                />
            }

        </Box>
    );
}

export default CompanyAddress;